/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Membership } from '../models/Membership';
import type { NativeAccountHeader } from '../models/NativeAccountHeader';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MembershipService {

    /**
     * getMembership
     * Provides details about the authenticated user's membership, customer, and subscription
     * @returns Membership Successful request
     * @throws ApiError
     */
    public static getMembership({
        useReplica = true,
    }: {
        useReplica?: boolean,
    }): CancelablePromise<Membership> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/membership',
            query: {
                'useReplica': useReplica,
            },
            errors: {
                400: `Authenticated user does not have a subscription in Stripe`,
                401: `Invalid authorization`,
                404: `No membership found for authenticated user`,
                500: `Something went wrong, most likely an issue getting details from Stripe`,
            },
        });
    }

    /**
     * createMembership
     * Creates a membership for an account
     * @returns any Successful request
     * @throws ApiError
     */
    public static createMembership(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/membership',
            errors: {
                400: `A membership already exists for the provided account, or the request payload was invalid`,
                500: `An unknown server error occurred`,
            },
        });
    }

    /**
     * getAllMembers
     * Retrieves a paginated list of all the entries in the memberships table
     * @returns string Successfully responded with member memberships
     * @throws ApiError
     */
    public static getAllMembers({
        accountId,
        limit,
    }: {
        accountId?: number,
        limit?: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/membership/all',
            query: {
                'account_id': accountId,
                'limit': limit,
            },
            errors: {
                500: `Something went wrong`,
            },
        });
    }

    /**
     * getFoundingMembers
     * Retrieves a list of founding members, determined by the promotional_identifier field on the memberships table
     * @returns Membership Successfully responded with founding member memberships
     * @throws ApiError
     */
    public static getFoundingMembers({
        hasUpgraded,
        isActive,
    }: {
        hasUpgraded?: boolean,
        isActive?: boolean,
    }): CancelablePromise<Array<Membership>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/membership/founding-members',
            query: {
                'hasUpgraded': hasUpgraded,
                'isActive': isActive,
            },
            errors: {
                500: `Something went wrong`,
            },
        });
    }

    /**
     * getMembershipStatus
     * Returns the current status of the given member
     * @returns string Successful request
     * @throws ApiError
     */
    public static getMembershipStatus(): CancelablePromise<'elite' | 'legacy' | 'whoop-pending' | 'trialing' | 'invalid' | 'canceled' | 'past_due' | 'active'> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/membership/status',
            errors: {
                404: `No membership record found for given user id`,
            },
        });
    }

    /**
     * getNativeAccountHeader
     * Gets the BFF native account header content
     * @returns NativeAccountHeader Successful request
     * @throws ApiError
     */
    public static getNativeAccountHeader(): CancelablePromise<NativeAccountHeader> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/membership/native-account-header',
            errors: {
                400: `User is not on a trial`,
                404: `No membership found for user`,
                500: `Something went wrong, most likely an issue retrieving checkout products from Stripe`,
            },
        });
    }

    /**
     * createMembershipForProvisionalAccount
     * Creates a membership for provisional account
     * @returns any Successful request
     * @throws ApiError
     */
    public static createMembershipForProvisionalAccount(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/membership',
            errors: {
                400: `A membership already exists for the provided account, or the request payload was invalid`,
                500: `An unknown server error occurred`,
            },
        });
    }

}
